import axios from '../../helpers/interceptors';

import {
    TEST,
    CLEAR_CABINET_STATE,
    SET_SETTINGS_VERIFY_MODAL_STATUS,
    SET_SETTINGS_ADD_WALLET_MODAL_STATUS,
    SET_SETTINGS_EDIT_WALLET_MODAL_STATUS,
    SET_STAKE_MODAL_STATUS,
    SET_FREEZE_OMT_HONEE_MODAL_STATUS,
    SET_EXTEND_FREEZE_MODAL_STATUS,
    CLEAR_VERIFY_EMAIL_ERROR,
    GET_PROJECTS_ALL_STARTED,
    GET_PROJECTS_ALL_SUCCESS,
    GET_PROJECTS_ALL_FAILURE,
    GET_PROJECT_STARTED,
    GET_PROJECT_SUCCESS,
    GET_PROJECT_FAILURE,
    GET_USER_DATA_STARTED,
    GET_USER_DATA_SUCCESS,
    GET_USER_DATA_FAILURE,
    SET_USER_NAME_STARTED,
    SET_USER_NAME_SUCCESS,
    SET_USER_NAME_FAILURE,
    DISCONNECT_USER_STARTED,
    DISCONNECT_USER_SUCCESS,
    DISCONNECT_USER_FAILURE,
    GET_LAUNCHPAD_STATUSES_STARTED,
    GET_LAUNCHPAD_STATUSES_SUCCESS,
    GET_LAUNCHPAD_STATUSES_FAILURE,
    CHANGE_USER_NAME_STARTED,
    CHANGE_USER_NAME_SUCCESS,
    CHANGE_USER_NAME_FAILURE,
    CHANGE_USER_AVATAR_STARTED,
    CHANGE_USER_AVATAR_SUCCESS,
    CHANGE_USER_AVATAR_FAILURE,
    GET_USER_PROJECTS_STARTED,
    GET_USER_PROJECTS_SUCCESS,
    GET_USER_PROJECTS_FAILURE,
    CHANGE_USER_EMAIL_STARTED,
    CHANGE_USER_EMAIL_SUCCESS,
    CHANGE_USER_EMAIL_FAILURE,
    RESEND_VERIFY_CODE_STARTED,
    RESEND_VERIFY_CODE_SUCCESS,
    RESEND_VERIFY_CODE_FAILURE,
    VERIFY_USER_EMAIL_STARTED,
    VERIFY_USER_EMAIL_SUCCESS,
    VERIFY_USER_EMAIL_FAILURE,
    GET_USER_ADDED_WALLETS_STARTED,
    GET_USER_ADDED_WALLETS_SUCCESS,
    GET_USER_ADDED_WALLETS_FAILURE,
    GET_WALLETS_NETWORKS_STARTED,
    GET_WALLETS_NETWORKS_SUCCESS,
    GET_WALLETS_NETWORKS_FAILURE,
    ADD_WALLET_STARTED,
    ADD_WALLET_SUCCESS,
    ADD_WALLET_FAILURE,
    EDIT_WALLET_STARTED,
    EDIT_WALLET_SUCCESS,
    EDIT_WALLET_FAILURE,
    GET_TOKEN_FREEZE_DATA_STARTED,
    GET_TOKEN_FREEZE_DATA_SUCCESS,
    GET_TOKEN_FREEZE_DATA_FAILURE,
    FREEZE_OMT_WITH_HONEE_STARTED,
    FREEZE_OMT_WITH_HONEE_SUCCESS,
    FREEZE_OMT_WITH_HONEE_FAILURE,
    GET_FREEZE_HISTORY_STARTED,
    GET_FREEZE_HISTORY_SUCCESS,
    GET_FREEZE_HISTORY_FAILURE,
    EXTEND_FREEZE_STARTED,
    EXTEND_FREEZE_SUCCESS,
    EXTEND_FREEZE_FAILURE,
    CLOSE_FREEZE_STARTED,
    CLOSE_FREEZE_SUCCESS,
    CLOSE_FREEZE_FAILURE,
    JOIN_PROJECT_STARTED,
    JOIN_PROJECT_SUCCESS,
    JOIN_PROJECT_FAILURE,
    GET_LAUNCHPAD_MAIN_STARTED,
    GET_LAUNCHPAD_MAIN_SUCCESS,
    GET_LAUNCHPAD_MAIN_FAILURE,
    GET_PROJECTS_LAST_STARTED,
    GET_PROJECTS_LAST_SUCCESS,
    GET_PROJECTS_LAST_FAILURE,
    SET_SETTINGS_ALLOCATION_DETAILS_MODAL_STATUS,
    SET_ALLOCATION_MODAL_STATUS,
    SET_ALLOCATION_HONEE_INVEST_STARTED,
    SET_ALLOCATION_HONEE_INVEST_SUCCESS,
    SET_ALLOCATION_HONEE_INVEST_FAILURE,
    SET_ALLOCATION_QR_INVEST_STARTED,
    SET_ALLOCATION_QR_INVEST_SUCCESS,
    SET_ALLOCATION_QR_INVEST_FAILURE,
    GET_USER_ALLOCATION_STARTED,
    GET_USER_ALLOCATION_SUCCESS,
    GET_USER_ALLOCATION_FAILURE,
    SET_ALLOCATION_HASH_STARTED,
    SET_ALLOCATION_HASH_SUCCESS,
    SET_ALLOCATION_HASH_FAILURE,
    GET_ALLOCATION_VESTING_DETAILS_STARTED,
    GET_ALLOCATION_VESTING_DETAILS_SUCCESS,
    GET_ALLOCATION_VESTING_DETAILS_FAILURE,
    CHECK_ACADEMY_STARTED,
    CHECK_ACADEMY_SUCCESS,
    CHECK_ACADEMY_FAILURE,
    WALLET_TRANSACTION_CHECK_STARTED,
    WALLET_TRANSACTION_CHECK_SUCCESS,
    WALLET_TRANSACTION_CHECK_FAILURE,
    GET_PREVIEW_PROJECT_STARTED,
    GET_PREVIEW_PROJECT_SUCCESS,
    GET_PREVIEW_PROJECT_FAILURE
} from "./types";

import {api} from "../../api";
import {setAuthorizationStatus} from "../main/action";
const host = api.host;


// const headWT = ()=>{
//     const token = localStorage.getItem('lp-token');
//     return {
//         headers: {
//             'Authorization': `Bearer ${token}`,
//             'Accept': 'application/json',
//             'Content-Type': 'application/json'
//         }
//     }
// }

const headWT = (withFormData = false) => {
    const token = localStorage.getItem('lp-token');

    const headers = {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json'
    };

    if (!withFormData) {
        headers['Content-Type'] = 'application/json';
    }

    return { headers };
};

export const clearCabinetState = () => ({
    type: CLEAR_CABINET_STATE
});


export const test = data => ({
    type: TEST,
    payload: data
});

export const setStakeModalStatus = status => ({
    type: SET_STAKE_MODAL_STATUS,
    payload: status
});

export const setAllocationModalStatus = status => ({
    type: SET_ALLOCATION_MODAL_STATUS,
    payload: status
});

export const setSettingsAllocationDetailsModalStatus = status => ({
    type: SET_SETTINGS_ALLOCATION_DETAILS_MODAL_STATUS,
    payload: status
});

export const setFreezeOmtModalStatus = status => ({
    type: SET_FREEZE_OMT_HONEE_MODAL_STATUS,
    payload: status
});

export const setExtendFreezeModalStatus = status => ({
    type: SET_EXTEND_FREEZE_MODAL_STATUS,
    payload: status
});

export const setSettingsVerifyModalStatus = status => ({
    type: SET_SETTINGS_VERIFY_MODAL_STATUS,
    payload: status
});

export const setSettingsAddWalletModalStatus = status => ({
    type: SET_SETTINGS_ADD_WALLET_MODAL_STATUS,
    payload: status
});

export const setSettingsEditWalletModalStatus = data => ({
    type: SET_SETTINGS_EDIT_WALLET_MODAL_STATUS,
    payload: data
});

export const clearVerifyEmailError = status => ({
    type: CLEAR_VERIFY_EMAIL_ERROR,
    payload: status
});




export const getProjectsAll = ({ page = 1, count } = {}) => {
    // базовый URL пагинации
    let url = `${host}${api.cabinet.projectsAll}/paginate`;

    // собираем query-параметры
    const params = [];

    if (page) {
        params.push(`page=${page}`);
    }

    if (count) {
        params.push(`count=${count}`);
    }

    if (params.length > 0) {
        url += `?${params.join('&')}`;
    }

    return dispatch => {
        dispatch(getProjectsAllStarted());

        axios
            .get(url, headWT())
            .then(res => {
                // ожидаем, что сервер кладёт всё в response
                dispatch(getProjectsAllSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(getProjectsAllFailure(err));
            });
    };
};

const getProjectsAllStarted = () => ({
    type: GET_PROJECTS_ALL_STARTED,
});

export const getProjectsAllSuccess = serverReport => ({
    type: GET_PROJECTS_ALL_SUCCESS,
    payload: serverReport,
});

export const getProjectsAllFailure = error => ({
    type: GET_PROJECTS_ALL_FAILURE,
    payload: error,
});



export const getProject = (slug) => {
    let url = host + api.cabinet.projectsAll  + `/${slug}/show`;

    return dispatch => {
        dispatch(getProjectStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getProjectSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(getProjectFailure(err));
            });
    };
};

const getProjectStarted = () => ({
    type: GET_PROJECT_STARTED
});

export const getProjectSuccess = serverReport => ({
    type: GET_PROJECT_SUCCESS,
    payload: serverReport
});

export const getProjectFailure = error => ({
    type: GET_PROJECT_FAILURE,
    payload: error
});


export const getUserData = () => {
    let url = host + api.cabinet.user;

    return dispatch => {
        dispatch(getUserDataStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getUserDataSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(getUserDataFailure(err));
            });
    };
};

const getUserDataStarted = () => ({
    type: GET_USER_DATA_STARTED
});

export const getUserDataSuccess = serverReport => ({
    type: GET_USER_DATA_SUCCESS,
    payload: serverReport
});

export const getUserDataFailure = error => ({
    type: GET_USER_DATA_FAILURE,
    payload: error
});


export const setUserName = (data) => {
    let url = host + api.cabinet.setUserName;

    return dispatch => {
        dispatch(setUserNameStarted());
        axios.post(url, data, headWT())
            .then(res => {
                dispatch(setUserNameSuccess(res.data.response));
                dispatch(getUserData());
            })
            .catch(err => {
                dispatch(setUserNameFailure(err.response.data.errors));
            });
    };
};

const setUserNameStarted = () => ({
    type: SET_USER_NAME_STARTED
});

export const setUserNameSuccess = serverReport => ({
    type: SET_USER_NAME_SUCCESS,
    payload: serverReport
});

export const setUserNameFailure = error => ({
    type: SET_USER_NAME_FAILURE,
    payload: error
});


export const disconnectUser = () => {
    let url = host + api.cabinet.disconnect;

    return dispatch => {
        dispatch(disconnectUserStarted());
        axios.post(url, null, headWT())
            .then(res => {
                localStorage.removeItem('lp-token');
                dispatch(setAuthorizationStatus(false));
                dispatch(clearCabinetState());
                dispatch(disconnectUserSuccess(res.data.response));
            })
            .catch(err => {
                localStorage.removeItem('lp-token');
                dispatch(setAuthorizationStatus(false));
                dispatch(clearCabinetState());
                dispatch(disconnectUserFailure(err));
            });
    };
};

const disconnectUserStarted = () => ({
    type: DISCONNECT_USER_STARTED
});

export const disconnectUserSuccess = serverReport => ({
    type: DISCONNECT_USER_SUCCESS,
    payload: serverReport
});

export const disconnectUserFailure = error => ({
    type: DISCONNECT_USER_FAILURE,
    payload: error
});


export const getLaunchpadStatuses = () => {
    let url = host + api.cabinet.statuses;

    return dispatch => {
        dispatch(getLaunchpadStatusesStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getLaunchpadStatusesSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(getLaunchpadStatusesFailure(err));
            });
    };
};

const getLaunchpadStatusesStarted = () => ({
    type: GET_LAUNCHPAD_STATUSES_STARTED
});

export const getLaunchpadStatusesSuccess = serverReport => ({
    type: GET_LAUNCHPAD_STATUSES_SUCCESS,
    payload: serverReport
});

export const getLaunchpadStatusesFailure = error => ({
    type: GET_LAUNCHPAD_STATUSES_FAILURE,
    payload: error
});


export const changeUserName = (data) => {
    let url = host + api.settings.setName;

    return dispatch => {
        dispatch(changeUserNameStarted());
        axios.put(url, data, headWT())
            .then(res => {
                dispatch(changeUserNameSuccess(res));
                dispatch(getUserData());
            })
            .catch(err => {
                dispatch(changeUserNameFailure(err.response.data.errors));
            });
    };
};

const changeUserNameStarted = () => ({
    type: CHANGE_USER_NAME_STARTED
});

export const changeUserNameSuccess = serverReport => ({
    type: CHANGE_USER_NAME_SUCCESS,
    payload: serverReport
});

export const changeUserNameFailure = error => ({
    type: CHANGE_USER_NAME_FAILURE,
    payload: error
});


export const changeUserAvatar = (file) => {
    const url = host + api.settings.setAvatar;

    const formData = new FormData();
    formData.append('image', file);

    return (dispatch) => {
        dispatch(changeUserAvatarStarted());
        axios.post(url, formData, headWT(true))
            .then((res) => {
                dispatch(changeUserAvatarSuccess(res));
                dispatch(getUserData());
            })
            .catch((err) => {
                dispatch(changeUserAvatarFailure(err.response?.data?.errors));
            });
    };
};

const changeUserAvatarStarted = () => ({
    type: CHANGE_USER_AVATAR_STARTED
});

export const changeUserAvatarSuccess = serverReport => ({
    type: CHANGE_USER_AVATAR_SUCCESS,
    payload: serverReport
});

export const changeUserAvatarFailure = error => ({
    type: CHANGE_USER_AVATAR_FAILURE,
    payload: error
});


export const getUserProjects = () => {
    const url = host + api.cabinet.userProjects;


    return (dispatch) => {
        dispatch(getUserProjectsStarted());
        axios.get(url,  headWT(true))
            .then((res) => {
                dispatch(getUserProjectsSuccess(res?.data?.response?.projects));
            })
            .catch((err) => {
                dispatch(getUserProjectsFailure(err));
            });
    };
};

const getUserProjectsStarted = () => ({
    type: GET_USER_PROJECTS_STARTED
});

export const getUserProjectsSuccess = serverReport => ({
    type: GET_USER_PROJECTS_SUCCESS,
    payload: serverReport
});

export const getUserProjectsFailure = error => ({
    type: GET_USER_PROJECTS_FAILURE,
    payload: error
});


export const changeUserEmail = (data) => {
    let url = host + api.settings.setEmail;

    return dispatch => {
        dispatch(changeUserEmailStarted());
        axios.post(url, data, headWT())
            .then(res => {
                dispatch(changeUserEmailSuccess(res));
                dispatch(getUserData());
            })
            .catch(err => {
                dispatch(changeUserEmailFailure(err.response.data.errors));
            });
    };
};

const changeUserEmailStarted = () => ({
    type: CHANGE_USER_EMAIL_STARTED
});

export const changeUserEmailSuccess = serverReport => ({
    type: CHANGE_USER_EMAIL_SUCCESS,
    payload: serverReport
});

export const changeUserEmailFailure = error => ({
    type: CHANGE_USER_EMAIL_FAILURE,
    payload: error
});


export const resendVerifyCode = () => {
    let url = host + api.settings.resendCode;

    return dispatch => {
        dispatch(resendVerifyCodeStarted());
        axios.post(url, null, headWT())
            .then(res => {
                dispatch(resendVerifyCodeSuccess(res));
            })
            .catch(err => {
                dispatch(resendVerifyCodeFailure(err));
            });
    };
};

const resendVerifyCodeStarted = () => ({
    type: RESEND_VERIFY_CODE_STARTED
});

export const resendVerifyCodeSuccess = serverReport => ({
    type: RESEND_VERIFY_CODE_SUCCESS,
    payload: serverReport
});

export const resendVerifyCodeFailure = error => ({
    type: RESEND_VERIFY_CODE_FAILURE,
    payload: error
});


export const verifyUserEmail = (data) => {
    let url = host + api.settings.verifyEmail;

    return dispatch => {
        dispatch(verifyUserEmailStarted());
        axios.post(url, data, headWT())
            .then(res => {
                dispatch(verifyUserEmailSuccess(res));
                dispatch(getUserData());
            })
            .catch(err => {
                dispatch(verifyUserEmailFailure(err.response.data.response.errors));
            });
    };
};

const verifyUserEmailStarted = () => ({
    type: VERIFY_USER_EMAIL_STARTED
});

export const verifyUserEmailSuccess = serverReport => ({
    type: VERIFY_USER_EMAIL_SUCCESS,
    payload: serverReport
});

export const verifyUserEmailFailure = error => ({
    type: VERIFY_USER_EMAIL_FAILURE,
    payload: error
});


export const getUserAddedWallets = () => {
    let url = host + api.settings.addedWallets;

    return dispatch => {
        dispatch(getUserAddedWalletsStarted());
        axios.get(url,  headWT())
            .then(res => {
                dispatch(getUserAddedWalletsSuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getUserAddedWalletsFailure(err));
            });
    };
};

const getUserAddedWalletsStarted = () => ({
    type: GET_USER_ADDED_WALLETS_STARTED
});

export const getUserAddedWalletsSuccess = serverReport => ({
    type: GET_USER_ADDED_WALLETS_SUCCESS,
    payload: serverReport
});

export const getUserAddedWalletsFailure = error => ({
    type: GET_USER_ADDED_WALLETS_FAILURE,
    payload: error
});


export const getWalletsNetworks = () => {
    let url = host + api.settings.getNetworks;

    return dispatch => {
        dispatch(getWalletsNetworksStarted());
        axios.get(url,  headWT())
            .then(res => {
                dispatch(getWalletsNetworksSuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getWalletsNetworksFailure(err));
            });
    };
};

const getWalletsNetworksStarted = () => ({
    type: GET_WALLETS_NETWORKS_STARTED
});

export const getWalletsNetworksSuccess = serverReport => ({
    type: GET_WALLETS_NETWORKS_SUCCESS,
    payload: serverReport
});

export const getWalletsNetworksFailure = error => ({
    type: GET_WALLETS_NETWORKS_FAILURE,
    payload: error
});


export const addWallet = (data) => {
    let url = host + api.settings.addWallet;

    return dispatch => {
        dispatch(addWalletStarted());
        axios.put(url, data, headWT())
            .then(res => {
                dispatch(addWalletSuccess(res));
                dispatch(getUserAddedWallets());
            })
            .catch(err => {
                dispatch(addWalletFailure(err.response.data.errors));
            });
    };
};

const addWalletStarted = () => ({
    type: ADD_WALLET_STARTED
});

export const addWalletSuccess = serverReport => ({
    type: ADD_WALLET_SUCCESS,
    payload: serverReport
});

export const addWalletFailure = error => ({
    type: ADD_WALLET_FAILURE,
    payload: error
});


export const editWallet = (data) => {
    let url = host + api.settings.addWallet;

    return dispatch => {
        dispatch(editWalletStarted());
        axios.put(url, data, headWT())
            .then(res => {
                dispatch(editWalletSuccess(res));
                dispatch(getUserAddedWallets());
            })
            .catch(err => {
                dispatch(editWalletFailure(err.response.data.errors));
            });
    };
};

const editWalletStarted = () => ({
    type: EDIT_WALLET_STARTED
});

export const editWalletSuccess = serverReport => ({
    type: EDIT_WALLET_SUCCESS,
    payload: serverReport
});

export const editWalletFailure = error => ({
    type: EDIT_WALLET_FAILURE,
    payload: error
});

export const getTokenFreezeData = () => {
    let url = host + api.cabinet.freezeData;

    return dispatch => {
        dispatch(getTokenFreezeDataStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getTokenFreezeDataSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(getTokenFreezeDataFailure(err));
            });
    };
};

const getTokenFreezeDataStarted = () => ({
    type: GET_TOKEN_FREEZE_DATA_STARTED
});

export const getTokenFreezeDataSuccess = serverReport => ({
    type: GET_TOKEN_FREEZE_DATA_SUCCESS,
    payload: serverReport
});

export const getTokenFreezeDataFailure = error => ({
    type: GET_TOKEN_FREEZE_DATA_FAILURE,
    payload: error
});


export const freezeOmtWithHonee = (data) => {
    let url = host + api.cabinet.freezeWH;

    return dispatch => {
        dispatch(freezeOmtWithHoneeStarted());
        axios.post(url, data, headWT())
            .then(res => {
                dispatch(freezeOmtWithHoneeSuccess(res));
            })
            .catch(err => {
                dispatch(freezeOmtWithHoneeFailure(err));
            });
    };
};

const freezeOmtWithHoneeStarted = () => ({
    type: FREEZE_OMT_WITH_HONEE_STARTED
});

export const freezeOmtWithHoneeSuccess = serverReport => ({
    type: FREEZE_OMT_WITH_HONEE_SUCCESS,
    payload: serverReport
});

export const freezeOmtWithHoneeFailure = error => ({
    type: FREEZE_OMT_WITH_HONEE_FAILURE,
    payload: error
});


export const getFreezeHistory = (status, page = 1, { append = false } = {}) => {
    const url = host + api.cabinet.freezeHistory;

    // соберём query-параметры
    const params = {};
    if (status) params.status = status;
    if (page)   params.page   = page;

    return (dispatch) => {
        dispatch(getFreezeHistoryStarted({ append, page, status }));

        // headWT() — оставляем, но добавим params в конфиг запроса
        const cfg = { ...headWT(), params };

        // ВАЖНО: вернуть промис, чтобы компонент мог делать .finally()
        return axios.get(url, cfg)
            .then((res) => {
                dispatch(getFreezeHistorySuccess(res.data.response, { append, page, status }));
                return res;
            })
            .catch((err) => {
                dispatch(getFreezeHistoryFailure(err, { append, page, status }));
                throw err;
            });
    };
};

const getFreezeHistoryStarted = (meta) => ({
    type: GET_FREEZE_HISTORY_STARTED,
    meta, // { append, page, status }
});

export const getFreezeHistorySuccess = (serverReport, meta) => ({
    type: GET_FREEZE_HISTORY_SUCCESS,
    payload: serverReport,
    meta, // { append, page, status }
});

export const getFreezeHistoryFailure = (error, meta) => ({
    type: GET_FREEZE_HISTORY_FAILURE,
    payload: error,
    error: true,
    meta,
});



export const extendFreeze = (data, id) => {
    let url = host + api.cabinet.freezeExtend  + `/${id}/continue`;

    return dispatch => {
        dispatch(extendFreezeStarted());
        axios.post(url, data, headWT())
            .then(res => {
                dispatch(extendFreezeSuccess(res));
                dispatch(getFreezeHistory());
            })
            .catch(err => {
                dispatch(extendFreezeFailure(err));
            });
    };
};

const extendFreezeStarted = () => ({
    type: EXTEND_FREEZE_STARTED
});

export const extendFreezeSuccess = serverReport => ({
    type: EXTEND_FREEZE_SUCCESS,
    payload: serverReport
});

export const extendFreezeFailure = error => ({
    type: EXTEND_FREEZE_FAILURE,
    payload: error
});


export const closeFreeze = (id) => {
    let url = host + api.cabinet.freezeExtend  + `/${id}/close`;

    return dispatch => {
        dispatch(closeFreezeStarted());
        axios.post(url, null, headWT())
            .then(res => {
                dispatch(closeFreezeSuccess(res));
                dispatch(getFreezeHistory());
            })
            .catch(err => {
                dispatch(closeFreezeFailure(err));
            });
    };
};

const closeFreezeStarted = () => ({
    type: CLOSE_FREEZE_STARTED
});

export const closeFreezeSuccess = serverReport => ({
    type: CLOSE_FREEZE_SUCCESS,
    payload: serverReport
});

export const closeFreezeFailure = error => ({
    type: CLOSE_FREEZE_FAILURE,
    payload: error
});


export const joinProject = (id) => {
    let url = host + api.cabinet.joinProject  + `/${id}`;

    return dispatch => {
        dispatch(joinProjectStarted());
        axios.post(url, null, headWT())
            .then(res => {
                dispatch(joinProjectSuccess(res));
                dispatch(getProject(id));
            })
            .catch(err => {
                dispatch(joinProjectFailure(err));
            });
    };
};

const joinProjectStarted = () => ({
    type: JOIN_PROJECT_STARTED
});

export const joinProjectSuccess = serverReport => ({
    type: JOIN_PROJECT_SUCCESS,
    payload: serverReport
});

export const joinProjectFailure = error => ({
    type: JOIN_PROJECT_FAILURE,
    payload: error
});


export const getLaunchpadMain = () => {
    let url = host + api.cabinet.launchpadMain;

    return dispatch => {
        dispatch(getLaunchpadMainStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getLaunchpadMainSuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getLaunchpadMainFailure(err));
            });
    };
};

const getLaunchpadMainStarted = () => ({
    type: GET_LAUNCHPAD_MAIN_STARTED
});

export const getLaunchpadMainSuccess = serverReport => ({
    type: GET_LAUNCHPAD_MAIN_SUCCESS,
    payload: serverReport
});

export const getLaunchpadMainFailure = error => ({
    type: GET_LAUNCHPAD_MAIN_FAILURE,
    payload: error
});


export const getProjectsLast = ({ count } = {}) => {
    // базовый URL пагинации
    let url = `${host}${api.cabinet.projectsAll}`;

    // собираем query-параметры
    const params = [];

    if (count) {
        params.push(`count=${count}`);
    }

    return dispatch => {
        dispatch(getProjectsLastStarted());

        axios
            .get(url, headWT())
            .then(res => {
                // ожидаем, что сервер кладёт всё в response
                dispatch(getProjectsLastSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(getProjectsLastFailure(err));
            });
    };
};

const getProjectsLastStarted = () => ({
    type: GET_PROJECTS_LAST_STARTED,
});

export const getProjectsLastSuccess = serverReport => ({
    type: GET_PROJECTS_LAST_SUCCESS,
    payload: serverReport,
});

export const getProjectsLastFailure = error => ({
    type: GET_PROJECTS_LAST_FAILURE,
    payload: error,
});


export const setAllocationHoneeInvest = (slug, data) => {
    const url = host + api.cabinet.userProjects + `/${slug}/allocation/invest/via-honee`;

    return (dispatch) => {
        dispatch(setAllocationHoneeInvestStarted());

        // ✅ IMPORTANT: return promise
        return axios.post(url, data, headWT())
            .then((res) => {
                dispatch(setAllocationHoneeInvestSuccess(res));
                // ✅ возвращаем payload, чтобы компонент мог проверить
                return res.data ?? res;
            })
            .catch((err) => {
                dispatch(setAllocationHoneeInvestFailure(err));
                // ✅ IMPORTANT: пробрасываем ошибку наружу
                throw err;
            });
    };
};

const setAllocationHoneeInvestStarted = () => ({
    type: SET_ALLOCATION_HONEE_INVEST_STARTED
});

export const setAllocationHoneeInvestSuccess = serverReport => ({
    type: SET_ALLOCATION_HONEE_INVEST_SUCCESS,
    payload: serverReport
});

export const setAllocationHoneeInvestFailure = error => ({
    type: SET_ALLOCATION_HONEE_INVEST_FAILURE,
    payload: error
});


export const setAllocationQrInvest = () => {
    let url = host + api.cabinet.qrInvest;

    return dispatch => {
        dispatch(setAllocationQrInvestStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(setAllocationQrInvestSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(setAllocationQrInvestFailure(err));
            });
    };
};

const setAllocationQrInvestStarted = () => ({
    type: SET_ALLOCATION_QR_INVEST_STARTED
});

export const setAllocationQrInvestSuccess = serverReport => ({
    type: SET_ALLOCATION_QR_INVEST_SUCCESS,
    payload: serverReport
});

export const setAllocationQrInvestFailure = error => ({
    type: SET_ALLOCATION_QR_INVEST_FAILURE,
    payload: error
});


export const getUserAllocation = () => {
    let url = host + api.cabinet.userAllocation;

    return dispatch => {
        dispatch(getUserAllocationStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getUserAllocationSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(getUserAllocationFailure(err));
            });
    };
};

const getUserAllocationStarted = () => ({
    type: GET_USER_ALLOCATION_STARTED
});

export const getUserAllocationSuccess = serverReport => ({
    type: GET_USER_ALLOCATION_SUCCESS,
    payload: serverReport
});

export const getUserAllocationFailure = error => ({
    type: GET_USER_ALLOCATION_FAILURE,
    payload: error
});


export const setAllocationHash = (slug, data) => {
    let url = host + api.cabinet.userProjects  + `/${slug}/allocation/invest/via-internal`;

    return dispatch => {
        dispatch(setAllocationHashStarted());
        axios.post(url, data, headWT())
            .then(res => {
                dispatch(setAllocationHashSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(setAllocationHashFailure(err));
            });
    };
};

const setAllocationHashStarted = () => ({
    type: SET_ALLOCATION_HASH_STARTED
});

export const setAllocationHashSuccess = serverReport => ({
    type: SET_ALLOCATION_HASH_SUCCESS,
    payload: serverReport
});

export const setAllocationHashFailure = error => ({
    type: SET_ALLOCATION_HASH_FAILURE,
    payload: error
});


export const getAllocationVestingDetails = (slug) => {
    let url = host + api.cabinet.userProjects  + `/${slug}/allocation/vesting-schedule`;

    return dispatch => {
        dispatch(getAllocationVestingDetailsStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getAllocationVestingDetailsSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(getAllocationVestingDetailsFailure(err));
            });
    };
};

const getAllocationVestingDetailsStarted = () => ({
    type: GET_ALLOCATION_VESTING_DETAILS_STARTED
});

export const getAllocationVestingDetailsSuccess = serverReport => ({
    type: GET_ALLOCATION_VESTING_DETAILS_SUCCESS,
    payload: serverReport
});

export const getAllocationVestingDetailsFailure = error => ({
    type: GET_ALLOCATION_VESTING_DETAILS_FAILURE,
    payload: error
});


export const checkAcademy = () => {
    let url = host + api.cabinet.checkAcademy;

    return dispatch => {
        dispatch(checkAcademyStarted());
        axios.post(url, null, headWT())
            .then(res => {
                dispatch(checkAcademySuccess(res));
                dispatch(getUserData());
            })
            .catch(err => {
                dispatch(checkAcademyFailure(err));
            });
    };
};

const checkAcademyStarted = () => ({
    type: CHECK_ACADEMY_STARTED
});

export const checkAcademySuccess = serverReport => ({
    type: CHECK_ACADEMY_SUCCESS,
    payload: serverReport
});

export const checkAcademyFailure = error => ({
    type: CHECK_ACADEMY_FAILURE,
    payload: error
});


export const walletTransactionCheck = (data) => {
    let url = host + api.cabinet.wtCheck;

    return dispatch => {
        dispatch(walletTransactionCheckStarted());
        axios.post(url, data, headWT())
            .then(res => {
                dispatch(walletTransactionCheckSuccess(res));
            })
            .catch(err => {
                dispatch(walletTransactionCheckFailure(err));
            });
    };
};

const walletTransactionCheckStarted = () => ({
    type: WALLET_TRANSACTION_CHECK_STARTED
});

export const walletTransactionCheckSuccess = serverReport => ({
    type: WALLET_TRANSACTION_CHECK_SUCCESS,
    payload: serverReport
});

export const walletTransactionCheckFailure = error => ({
    type: WALLET_TRANSACTION_CHECK_FAILURE,
    payload: error
});


export const getPreviewProject = (slug, errHandler) => {
    let url = host + api.cabinet.projectsAll  + `/${slug}/show/preview/top-secret`;

    return dispatch => {
        dispatch(getPreviewProjectStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getPreviewProjectSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(getPreviewProjectFailure(err));
                errHandler(err);
            });
    };
};

const getPreviewProjectStarted = () => ({
    type: GET_PREVIEW_PROJECT_STARTED
});

export const getPreviewProjectSuccess = serverReport => ({
    type: GET_PREVIEW_PROJECT_SUCCESS,
    payload: serverReport
});

export const getPreviewProjectFailure = error => ({
    type: GET_PREVIEW_PROJECT_FAILURE,
    payload: error
});
